import { MOCK_TEST_STATUS, MOCK_TEST_USER_STATUS } from '@app/constants/mockTest';
import { IExam } from './academic.api';
import { httpApi } from './http.api';

export interface IDetailMockTest {
  questions: IExam[];
}

export interface IMockTest {
  id: string;
  name: string;
  description: string;
  status: MOCK_TEST_STATUS;
  year: number;
  type: string;
  section: string;
}

export interface IMockTestHis {
  id: string;
  name: string;
  status: MOCK_TEST_USER_STATUS;
  overallscore: number;
}

export interface IMockTestResponse {
  data: IMockTest[];
  meta: {
    itemCount: number;
    page: number;
    pageCount: number;
  };
}

export interface IMockTestHisResponse {
  mockTest: IMockTest;
  userMockTest: IMockTestHis[];
}

export interface IMockTestUserRequest {
  mockTestId: string;
}

export interface IMockTestUserStart {
  mockTestId: string;
  remainTime: number;
  step: string;
}

export interface IMockTestUserUpdate {
  step: string;
  current_question: number;
}

export interface IMockTestUser {
  id: string;
  currentquestion: number;
  mocktestid: string;
  overallscore: number;
  remaintime: number;
  startdate: string;
  status: string;
  userid: string;
  step: string;
  mocktestname: string;
}
export interface IMockTestUserResponse {
  questions: IExam[];
  userMockTest: IMockTestUser;
}

export interface ITag {
  category: string;
  tags: [
    {
      name: string;
      key: string;
    },
  ];
}

export const getMockTests = (page: number, take: number, type: string, section: string): Promise<IMockTestResponse> => {
  let queryString = `page=${page}&take=${take}&type=${type}`;
  if (section) queryString += `&section=${section}`;
  return httpApi.get<IMockTestResponse>(`/mock-test?${queryString}`).then(({ data }) => data);
};

export const getTagList = (): Promise<ITag> => {
  return httpApi.get<ITag>(`/mock-test/tags`).then(({ data }) => data);
};

export const getMockTestsHis = (mockTestId: string): Promise<IMockTestHisResponse> => {
  const queryString = `mockTestId=${mockTestId}`;
  return httpApi.get<IMockTestHisResponse>(`/mock-test-user/history?${queryString}`).then(({ data }) => data);
};

export const mockTestResume = (mockTestId: string): Promise<IMockTestUserResponse> => {
  const queryString = `mockTestId=${mockTestId}`;
  return httpApi.get<IMockTestUserResponse>(`/mock-test-user/resume?${queryString}`).then(({ data }) => data);
};

export const mockTestStart = (payload: IMockTestUserRequest): Promise<any> =>
  httpApi.post<any>('/mock-test-user/start', { ...payload }).then(({ data }) => data);

export const mockTestCancel = (payload: IMockTestUserRequest): Promise<any> =>
  httpApi.post<any>('/mock-test-user/reset', { ...payload }).then(({ data }) => data);

export const saveProgressMockTest = (payload: FormData) =>
  httpApi.post<any>('/mock-test-user/answer-submit', payload).then(({ data }) => data);

export const mockTestFinish = (payload: IMockTestUserRequest): Promise<any> =>
  httpApi.post<any>('/mock-test-user/finish', { ...payload }).then(({ data }) => data);

export const mockTestDelete = (id: string): Promise<any> =>
  httpApi.delete<any>(`/mock-test-user/${id}`).then(({ data }) => data);

export const mockTestUpdate = (id: string, payload: IMockTestUserUpdate): Promise<any> =>
  httpApi.patch<any>(`/mock-test-user/${id}`, { ...payload }).then(({ data }) => data);
